export default __webpack_public_path__ + "static/media/tray.0a573ee5.png";